import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1f55dcf4")
const _hoisted_1 = { class: "p-grid col-padding" }
const _hoisted_2 = { class: "p-col-fixed p-as-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "p-col-8 underline p-as-center" }
const _hoisted_5 = { class: "p-col" }
const _hoisted_6 = {
  key: 0,
  class: "p-col-4"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "País", -1)
const _hoisted_9 = {
  key: 0,
  class: "p-grid p-d-flex p-jc-center"
}
const _hoisted_10 = {
  key: 1,
  class: "p-text-center"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("--")
const _hoisted_12 = { class: "p-grid p-jc-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-check",
  style: {"font-size":"1rem"}
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times",
  style: {"font-size":"1rem"}
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Carrerino", -1)
const _hoisted_20 = { class: "p-grid p-mt-2" }
const _hoisted_21 = ["for"]
const _hoisted_22 = { class: "p-grid p-text-center" }
const _hoisted_23 = { class: "p-col" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Categorias", -1)
const _hoisted_25 = { class: "p-grid p-mt-2" }
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "p-grid" }
const _hoisted_28 = {
  key: 0,
  class: "p-col"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Servicios", -1)
const _hoisted_30 = {
  class: "p-grid p-mt-2",
  style: {"max-width":"500px"}
}
const _hoisted_31 = ["for"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" No hay Estudiantes ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailSending = _resolveComponent("EmailSending")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_spam = _resolveComponent("spam")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_EmailSending, {
      visible: _ctx.emailModal,
      userName: _ctx.userName,
      activity: false,
      setMail: _ctx.emailInfo,
      contextId: 'emails'
    }, null, 8, ["visible", "userName", "setMail"]),
    _createVNode(_component_DataTable, {
      class: "performance-table p-datatable-ssm",
      rows: _ctx.recordsPerPage,
      value: _ctx.studentsRef,
      dataKey: "courseNumber",
      responsiveLayout: "scroll",
      loading: !_ctx.studentsRef,
      filterDisplay: "menu",
      filters: _ctx.filters,
      "onUpdate:filters": [
        _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        _ctx.updateFilters
      ],
      totalRecords: _ctx.totalRecords,
      lazy: true,
      first: _ctx.firstRecord
    }, {
      empty: _withCtx(() => [
        _hoisted_32
      ]),
      default: _withCtx(() => [
        (_ctx.showCol.includes('Nombre'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              header: "Nombre",
              showFilterMatchModes: false,
              filterField: "countries"
            }, {
              body: _withCtx((data) => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("i", {
                      onClick: ($event: any) => (_ctx.showEmailModal(data)),
                      class: "pi pi pi-envelope mouse-icon"
                    }, null, 8, _hoisted_3)
                  ]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(data.data.profile.first_name) + " " + _toDisplayString(data.data.profile.last_name), 1),
                  _createElementVNode("div", _hoisted_5, [
                    (data.data.profile.country !== undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("img", {
                            src: _ctx.Country.getIconUrlFromCountryCode(data.data.profile.country),
                            alt: data.data.profile.country
                          }, null, 8, _hoisted_7)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              filter: _withCtx(({ filterModel }) => [
                _hoisted_8,
                _createVNode(_component_CountrySelector, {
                  class: "p-mt-3",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                  disabled: _ctx.loading
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]),
              filterclear: _withCtx(({filterCallback}) => [
                _createVNode(_component_Button, {
                  type: "button",
                  label: "Limpiar",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-text button-underlined"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showCol.includes('Comisiones'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 1,
              header: "Comisiones activas"
            }, {
              body: _withCtx((data) => [
                ((data?.data?.camadas.length || []) > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.camadas, (com) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "p-col-fixed underline",
                          key: com._id
                        }, [
                          _createVNode(_component_spam, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(com.id), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_spam, null, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showCol.includes('Carrerino'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 2,
              header: "Carrerino",
              showFilterMatchModes: false,
              filterField: "carrerino"
            }, {
              body: _withCtx((data) => [
                _createElementVNode("div", _hoisted_12, [
                  ((data?.data.profile?.onCareers || []).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                ])
              ]),
              filter: _withCtx(() => [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carrerinoOptions, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "p-col-12 p-field-checkbox",
                      key: option.key
                    }, [
                      _createVNode(_component_Checkbox, {
                        id: option.key,
                        name: "option",
                        disabled: _ctx.filters.carrerino.value !== null ? (_ctx.filters.carrerino.value.length > 0 && _ctx.filters.carrerino.value[0] !== option) : false,
                        value: option,
                        modelValue: _ctx.filters.carrerino.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters.carrerino.value = $event))
                      }, null, 8, ["id", "disabled", "value", "modelValue"]),
                      _createElementVNode("label", {
                        for: option.key
                      }, _toDisplayString(option.name), 9, _hoisted_21)
                    ]))
                  }), 128))
                ])
              ]),
              filterclear: _withCtx(({filterCallback}) => [
                _createVNode(_component_Button, {
                  type: "button",
                  label: "Limpiar",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-text button-underlined"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showCol.includes('Categorías'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 3,
              header: "Categorías",
              showFilterMatchModes: false,
              filterField: "categories"
            }, {
              body: _withCtx((data) => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString((data?.data?.subscription.length || []) > 0 ? data.data.subscription.join(' / ') : 'Sin categorías activas'), 1)
                ])
              ]),
              filter: _withCtx(() => [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryOptions, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "p-col-12 p-field-checkbox",
                      key: option.key
                    }, [
                      _createVNode(_component_Checkbox, {
                        id: option.key,
                        name: "option",
                        value: option,
                        modelValue: _ctx.filters.categories.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.categories.value = $event))
                      }, null, 8, ["id", "value", "modelValue"]),
                      _createElementVNode("label", {
                        for: option.key
                      }, _toDisplayString(option.name), 9, _hoisted_26)
                    ]))
                  }), 128))
                ])
              ]),
              filterclear: _withCtx(({filterCallback}) => [
                _createVNode(_component_Button, {
                  type: "button",
                  label: "Limpiar",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-text button-underlined"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showCol.includes('Servicios activos'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 4,
              header: "Servicios activos",
              showFilterMatchModes: false,
              filterField: "services"
            }, {
              body: _withCtx((data) => [
                _createElementVNode("div", _hoisted_27, [
                  ((data?.data.activeServices.length === 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Sin servicios activos "))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data?.data.activeServices, (service) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "p-col",
                          key: service.key
                        }, [
                          _createElementVNode("li", null, _toDisplayString(service), 1)
                        ]))
                      }), 128))
                ])
              ]),
              filter: _withCtx(() => [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesOptions, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "p-col-12 p-field-checkbox",
                      key: option.key
                    }, [
                      _createVNode(_component_Checkbox, {
                        id: option.key,
                        name: "option",
                        value: option,
                        modelValue: _ctx.filters.services.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters.services.value = $event))
                      }, null, 8, ["id", "value", "modelValue"]),
                      _createElementVNode("label", {
                        for: option.key
                      }, _toDisplayString(option.name), 9, _hoisted_31)
                    ]))
                  }), 128))
                ])
              ]),
              filterclear: _withCtx(({filterCallback}) => [
                _createVNode(_component_Button, {
                  type: "button",
                  label: "Limpiar",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-text button-underlined"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rows", "value", "loading", "filters", "totalRecords", "first", "onUpdate:filters"])
  ], 64))
}